export const CUSTOMER_CHAT_CURRENT_REQUEST = "CUSTOMER_CHAT_CURRENT_REQUEST";
export const CUSTOMER_CHAT_CURRENT_SUCCESS = "CUSTOMER_CHAT_CURRENT_SUCCESS";
export const CUSTOMER_CHAT_CURRENT_FAIL = "CUSTOMER_CHAT_CURRENT_FAIL";

export const CUSTOMER_CHAT_START_REQUEST = "CUSTOMER_CHAT_START_REQUEST";
export const CUSTOMER_CHAT_START_SUCCESS = "CUSTOMER_CHAT_START_SUCCESS";
export const CUSTOMER_CHAT_START_FAIL = "CUSTOMER_CHAT_START_FAIL";

export const CUSTOMER_CHAT_IDENTITY_REQUEST = "CUSTOMER_CHAT_IDENTITY_REQUEST";
export const CUSTOMER_CHAT_IDENTITY_SUCCESS = "CUSTOMER_CHAT_IDENTITY_SUCCESS";
export const CUSTOMER_CHAT_IDENTITY_FAIL = "CUSTOMER_CHAT_IDENTITY_FAIL";

export const CUSTOMER_CHAT_RESEND_REQUEST = "CUSTOMER_CHAT_RESEND_REQUEST";
export const CUSTOMER_CHAT_RESEND_SUCCESS = "CUSTOMER_CHAT_RESEND_SUCCESS";
export const CUSTOMER_CHAT_RESEND_FAIL = "CUSTOMER_CHAT_RESEND_FAIL";

export const CUSTOMER_CHAT_CLEAR_IDENTITY_REQUEST =
  "CUSTOMER_CHAT_CLEAR_IDENTITY_REQUEST";
export const CUSTOMER_CHAT_CLEAR_IDENTITY_SUCCESS =
  "CUSTOMER_CHAT_CLEAR_IDENTITY_SUCCESS";
export const CUSTOMER_CHAT_CLEAR_IDENTITY_FAIL =
  "CUSTOMER_CHAT_CLEAR_IDENTITY_FAIL";

export const CUSTOMER_CHAT_SEND_REQUEST = "CUSTOMER_CHAT_SEND_REQUEST";
export const CUSTOMER_CHAT_SEND_SUCCESS = "CUSTOMER_CHAT_SEND_SUCCESS";
export const CUSTOMER_CHAT_SEND_FAIL = "CUSTOMER_CHAT_SEND_FAIL";

export const CUSTOMER_CHAT_READ_SUCCESS = "CUSTOMER_CHAT_READ_SUCCESS";
export const CUSTOMER_CHAT_RECEIVE_MESSAGE = "CUSTOMER_CHAT_RECEIVE_MESSAGE";
export const CUSTOMER_CHAT_CONVERSATION_UPDATE =
  "CUSTOMER_CHAT_CONVERSATION_UPDATE";
export const CUSTOMER_CHAT_RESET = "CUSTOMER_CHAT_RESET";

export const ADMIN_CHAT_LIST_REQUEST = "ADMIN_CHAT_LIST_REQUEST";
export const ADMIN_CHAT_LIST_SUCCESS = "ADMIN_CHAT_LIST_SUCCESS";
export const ADMIN_CHAT_LIST_FAIL = "ADMIN_CHAT_LIST_FAIL";

export const ADMIN_CHAT_DETAILS_REQUEST = "ADMIN_CHAT_DETAILS_REQUEST";
export const ADMIN_CHAT_DETAILS_SUCCESS = "ADMIN_CHAT_DETAILS_SUCCESS";
export const ADMIN_CHAT_DETAILS_FAIL = "ADMIN_CHAT_DETAILS_FAIL";

export const ADMIN_CHAT_SEND_REQUEST = "ADMIN_CHAT_SEND_REQUEST";
export const ADMIN_CHAT_SEND_SUCCESS = "ADMIN_CHAT_SEND_SUCCESS";
export const ADMIN_CHAT_SEND_FAIL = "ADMIN_CHAT_SEND_FAIL";

export const ADMIN_CHAT_STATUS_REQUEST = "ADMIN_CHAT_STATUS_REQUEST";
export const ADMIN_CHAT_STATUS_SUCCESS = "ADMIN_CHAT_STATUS_SUCCESS";
export const ADMIN_CHAT_STATUS_FAIL = "ADMIN_CHAT_STATUS_FAIL";

export const ADMIN_CHAT_READ_SUCCESS = "ADMIN_CHAT_READ_SUCCESS";

export const ADMIN_CHAT_UNREAD_REQUEST = "ADMIN_CHAT_UNREAD_REQUEST";
export const ADMIN_CHAT_UNREAD_SUCCESS = "ADMIN_CHAT_UNREAD_SUCCESS";
export const ADMIN_CHAT_UNREAD_FAIL = "ADMIN_CHAT_UNREAD_FAIL";

export const ADMIN_CHAT_RECEIVE_MESSAGE = "ADMIN_CHAT_RECEIVE_MESSAGE";
export const ADMIN_CHAT_CONVERSATION_UPDATE = "ADMIN_CHAT_CONVERSATION_UPDATE";
export const ADMIN_CHAT_RESET_ACTIVE = "ADMIN_CHAT_RESET_ACTIVE";
